const WHATSAPP_NUMBER = "554191150056";
const DEFAULT_MESSAGE = "Olá, vim pelo site da Mango e quero conversar sobre um projeto.";

function buildWhatsappUrl(message = DEFAULT_MESSAGE) {
    return `https://api.whatsapp.com/send?phone=${WHATSAPP_NUMBER}&text=${encodeURIComponent(message)}`;
}

export { WHATSAPP_NUMBER, DEFAULT_MESSAGE, buildWhatsappUrl };
